import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata";
import { ConfettiBtn } from "@/components/ConfettiBtn"
import { StaticImage } from "gatsby-plugin-image";


function OurHosts() {

  return (
    <>
      <section>
          <div className="container px-4 md:px-6">
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-10">
              <div>
                <StaticImage
                  src="../images/sponsors/WESNET-Logos-square.png"
                  alt="Wesnet Logo"
                  height={200}
                  placeholder="blurred"
                  formats={["auto", "webp"]}
                  className="float-right ms-5"
                />
                <h2>Wesnet</h2>
                <p>Wesnet (the Women’s Services Network) Inc. provides relief and support to women and children experiencing domestic and family violence, intimate partner violence and other forms of gender-based violence. A national network, our members are the specialist domestic and family violence services across Australia.</p>
                <p>Wesnet is also the leading non-profit organisation in Australia working on the intersection of technology and violence against women. We work to ensure that women can remain connected through technology, that people who choose to misuse technology for abusive purposes are disrupted and held to account, and to educate and support individuals, organisations and broader society to end technology facilitated abuse.</p>
                <ConfettiBtn btnText="Visit website" link="https://wesnet.org.au/" />
              </div>

              <div>
                <StaticImage
                  src="../images/sponsors/GNWS.png"
                  alt="GNWS Logo"
                  height={200}
                  placeholder="blurred"
                  formats={["auto", "webp"]}
                  className="float-right ms-5"
                />
                <h2>Global Network of Women’s Shelters (GNWS)</h2>
                <p>The GNWS was born at the 1st World Conference of Women’s Shelters in Edmonton, Canada, in 2008 and founded in 2009 by a globally diverse group of national networks and shelters from around the world. It has networks in Africa, America, Asia, Europe, the Middle East & North Africa, and Oceania, working to: ensure global awareness of violence against women and their children; support and strengthen the women’s shelter movement; promote effective policies and their implementation in order to prevent violence and to protect and empower women and their children; and promote social change that ends violence and oppression against women.</p>
                <ConfettiBtn btnText="Visit website" link="https://gnws.org/" />
              </div>
            </div>
          </div>
      </section>
    </>
  )
}

export default OurHosts

export function Head() {
  const { title } = useSiteMetadata();
  return (
    <>
      <title>{`Our Hosts - ${title}`}</title>
      <meta name="description" content="Meet the hosts of the 5th World Conference of Women's Shelters 2025. Learn about the organizations and individuals dedicated to supporting women's shelters worldwide." />
      <meta name="keywords" content="5WCWS, WCWS, Women's Shelters, World Conference, 2025, our hosts, host organizations, Conference hosts, women's support" />
    </>
  )
}
